export default __webpack_public_path__ + "dumpert-play-8bcc6c.svg";